export const FIXED_ABBRS: Record<string, string> = {
    'Asia/Kuala_Lumpur': 'MYT',
    'Asia/Singapore': 'SGT',
    'Asia/Shanghai': 'CST',
    'Asia/Hong_Kong': 'HKT',
  };